<template>
  <div class="bg">
    <div class="sharetip" v-if="share" @click="share = false">
      <div class="s"></div>
    </div>
    <div class="bonus-center-box abs-mm">
      <div class="wheel">
        <div
          class="pointer"
          :style="{ transform: 'rotate(' + 0 + 'deg)' }"
        ></div>
        <div class="item g1"></div>
        <div class="item g1"></div>
        <div class="item g1"></div>
        <div class="item g1"></div>
        <div class="item g1"></div>
        <div class="item g1"></div>
        <div class="item g1"></div>
        <div class="item g1"></div>
      </div>
    </div>
    <div class="mask">
      <div class="inner-r">
        <div class="title"></div>
        <div class="txt">
          您的收货信息我们已经收录，请耐心等候！
          <br />
          我们将于 40 日内，以短信形式通知您快件信息。
        </div>
        <div
          class="btn b1"
          @click="
            $router.replace({ name: 'Home', query: { gameType: 'guide' } })
          "
        ></div>
        <div class="btn b2" @click="share = true"></div>
        <div class="btn b3" @click="go('http://www.baidu.com')"></div>
        <div
          class="btn b4"
          @click="$router.replace('/log?giftRoad=' + $route.query.giftRoad)"
        ></div>
        <div class="logo"></div>
      </div>
    </div>
  </div>
</template>

<script>
//script
import Tools from '../../scripts/tools';
import { gsap } from 'gsap';
//Global
import Global from '../../scripts/Global';
import api from '../../scripts/api';

export default {
  data() {
    return { share: false };
  },
  components: {},
  created() {},
  mounted() {},
  computed: {},
  methods: {
    go(p) {
      window.location.replace(p);
    },
  },
};
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.mask{
width: 100%;
  height: 100%;
  position: absolute;
  z-index: 0;
  background-color: rgba(255, 255, 255, 0.7);
  .inner-r{
      position: relative;
      width:100%;
      height: 100%;
  }
}
.bg {
    background-image: url(//cdn.original-fun.com/gugong/BG.jpg);
    background-position: center;
    width: 100vw;
    height: 100vh;
    max-width: 75vh;
    margin: 0 auto;
    overflow: hidden;
    background-size: cover;
    background-repeat: no-repeat;
}
.bonused-bg {
    background-image: url(//cdn.original-fun.com/gugong/答错提示框.png);
    background-position: center;
    background-repeat: no-repeat;
    background-size: contain;
    height: 1.5rem;
    width: 100%;
    top: 1.4rem;
    line-height: 1.5rem;
    color: #fff;
    position: absolute;
    .txt {
        margin: 0 0.8rem 0 0.8rem;
        line-height: 0.4rem;
        position: relative;
        display: flex;
        height: 100%;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        // word-break: keep-all;
    }
}
.bonus-center-box {margin-top: -0.5rem;height: 10rem;}
.title {
    background-image: url(//cdn.original-fun.com/gugong/恭喜获奖.png);
    background-position: center;
    width: 5rem;
    height: 1.5rem;
    background-size: contain;
    background-repeat: no-repeat;
    margin: 1rem auto 1rem auto;
}
.txt{
font-size: 12px;
}
.btn {
    background-position: center;
    background-size: contain;
    background-repeat: no-repeat;
    width: 3.5rem;
    height: 1rem;
    margin: 1rem auto 0 auto;
    z-index: 2;
    position: relative;
    &.b1 {
        background-image: url(//cdn.original-fun.com/gugong/button游览其他线路.png);
    }
    &.b2 {    margin: 0 auto;
        background-image: url(//cdn.original-fun.com/gugong/button分享给朋友.png);
    }
    &.b3 {    margin: 0 auto;
        background-image: url(//cdn.original-fun.com/gugong/button更多活动.png);
    }
     &.b4 {
        margin: 0 auto;
        background-image: url(//cdn.original-fun.com/gugong/button查看获奖记录.png);
    }
}
.wheel {
    width: 7.5rem;
    height: 10.52rem;
    background-image: url(//cdn.original-fun.com/gugong/转盘底.png);
    background-position: center;
    background-size: 100% auto;
    background-repeat: no-repeat;
    margin: 0 auto 0rem auto;
    pointer-events: none;
    position: relative;
    top: 0.5rem;
    .pointer {
        transform-origin: 50% 1.5rem;
        transition: all 3s;
        width: 1.3rem;
        height: 2rem;
        background-image: url(//cdn.original-fun.com/gugong/抽奖转盘指针.png);
        background-position: center;
        background-repeat: no-repeat;
        background-size: contain;
        position: absolute;
        left: 50%;
        margin-left: -0.65rem;
        top: 3.1rem
    }
}
.logo {
    background-image: url(//cdn.original-fun.com/gugong/品牌logo-白.png);
    background-position: center;
    width: 3rem;
    height: 1rem;
    background-repeat: no-repeat;
    background-size: contain;
    position: absolute;
    bottom: 0.4rem;
    left: 50%;
    margin-left: -1.5rem;
}
//中奖弹层
.virtual-gift-layer, .real-gift-layer {@include fullLayer;position: absolute;left: 0;top: 0;background:: rgba(222, 198, 188, .7);@include maskShow;z-index: 5;}
.gift-title {width: 4.51rem;height: 0.55rem;background-image: url(./../../assets/gift/gift-title.png);@include singleBg;margin: 0 auto;}
.gift-name {width: 2.6rem;height: 0.52rem;background-image: url(./../../assets/gift/gift-name-bg.png);@include singleBg;margin: 0 auto;margin-top: 0.3rem;color: #fff;font-size: 0.28rem;line-height: 0.52rem;text-align: center;}
.gift-img {width: 3.58rem;height: 2.5rem;background-image: url(./../../assets/gift/virtual-img.png);@include singleBg;margin: 0 auto;margin-top: 0.1rem;}
.gift-real-img {width: 3.58rem;height: 2.5rem;margin: 0 auto;margin-top: 0.1rem;}
.code-title {width: 3rem;
    text-align: center;
    margin: 0.2rem auto 0.2rem auto;}
.code-tips {font-size: 0.24rem;color: #fff;line-height: 1;position: relative;width: 3rem;text-align: center;margin: 0 auto;
    &:before {content: "";position: absolute;width: 0.8rem;height: 0.02rem;background: #fff;left: 0;top: 50%;margin-top: -0.01rem;}
    &:after {content: "";position: absolute;width: 0.8rem;height: 0.02rem;background: #fff;right: 0;top: 50%;margin-top: -0.01rem;}
}
.code-txt {margin-top: 0.2rem;font-weight: bold;font-size: 0.32rem;user-select: text}
.gift-btn-box {margin-top: 0.5rem;}
.gift-btn {width: 3.96rem;height: 0.94rem;@include singleBg;margin: 0 auto;margin-bottom: 0.1rem;}
.gift-btn-1 {background-image: url(./../../assets/gift/gift-btn-1.png);}
.gift-btn-2 {background-image: url(./../../assets/gift/gift-btn-2.png);}
.gift-btn-3 {background-image: url(./../../assets/gift/gift-btn-3.png);}
.gift-btn-4 {background-image: url(./../../assets/gift/gift-btn-4.png);}
.gift-btn-5 {background-image: url(./../../assets/gift/gift-btn-5.png);}
.input-box {white-space: nowrap; width: 5.6rem;display: flex;justify-content: space-between;align-items: center;
    input {padding: 0.1rem;width: 4rem;}
    margin-top: 0.2rem;}
.address-box {margin-top: 0.2rem;}
.address-title {text-align: left;}
.address-area {width: 5.6rem;margin-top: 0.1rem;border: none;resize: none;padding: 0.1rem;box-sizing: border-box;}
</style>
